import APIClient from './index';
import _ from 'lodash';

export const triggerScriptRun = data => {
  return new Promise((resolve, reject) => {
    APIClient.post('AdminScriptRuns', data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getScriptRunHistory = configId => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AdminScriptRuns/history/${configId}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getScriptRunLogs = runId => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AdminScriptRuns/${runId}/logs`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getScriptRunById = runId => {
  return new Promise((resolve, reject) => {
    APIClient.get(`AdminScriptRuns/${runId}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getScriptRuns = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get('AdminScriptRuns', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
